import {AfterViewInit, Component, OnChanges, ViewEncapsulation, ChangeDetectorRef, OnDestroy, OnInit, Input} from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { SelectSurveyModalComponent } from 'src/app/modules/questionnaire/components/select-survey-modal/select-survey-modal.component';
import { PlanService } from 'src/app/services/plan-status/plan-status.service';
import {PermissionsService} from "../../services/permissions/permissions.service";
import { SelectRequestModalComponent } from '../select-request-modal/select-request-modal.component';
import { SelectCheckTypeModalComponent } from '../select-check-type-modal/select-check-type-modal.component';
import * as Cookies from 'js-cookie';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import { PeopleService } from 'src/app/services/people/people.service';

@Component({
  selector: 'app-send-xref-button',
  templateUrl: './send-xref-button.component.pug',
  styleUrls: ['./send-xref-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SendXrefButtonComponent implements OnInit {

  @Input() preFill = false;
  selectCheckTypeModal: BsModalRef;
  noPermissionToSend = false;
  bsModalRef:any;
  planstatus = true;
  response:any;
  current_time:any;
  valid_start_time:any;
  valid_end_time:any
  state:any
  org_uid = Cookies.get(ConstantsService.ORG_COOKIE);

  constructor(public permissions: PermissionsService,
              public modalService: BsModalService,
              public peopleService: PeopleService,
              public planservice: PlanService,
              public router:Router,
              private cdr: ChangeDetectorRef) {
                  this.selectCheckTypeModal = new BsModalRef();
              }


  ngOnInit(): void {
    if (!this.permissions.hasPermission('can_view_send_request_button')) {
      this.noPermissionToSend = true;
    }

  }


  requestClicked(){
    this.state = this.planservice.getPlanState()
    this.valid_start_time = this.state.valid_from
    this.current_time = this.state.current_time
    this.valid_end_time = this.state.valid_till
    if (this.state.message != 'No plans found') {
      if (this.valid_start_time > this.current_time) {
        const formattedDate = moment.utc(this.valid_start_time).local().format('ll')
        const initialState = {
          message: $localize`Almost there! Your subscription will be activated on ${formattedDate}.`,
          showLink: false
        }
        this.bsModalRef = this.modalService.show(
          SelectRequestModalComponent,
          Object.assign({}, {
            class: 'modal-dialog-centered select-survey-new max-width-852 max-height-262 xxl-popup-product',
            initialState
          }),
        );

        const metaData = {
          "log":{
            "organisation_id": this.org_uid,
            "message": "Subscription not yet started"
          },
          "audit_log": "CLICK_REQUEST_FORBIDDEN"
        }
        this.planservice.postLog(metaData)

      } else if (this.valid_start_time < this.current_time && this.valid_end_time < this.current_time) {
        const formattedDate = moment.utc(this.valid_end_time).local().format('ll')
        let initialState = {
            message: $localize`Unfortunately, your subscription expired on ${formattedDate}. `,
            showLink: true
          }
        this.bsModalRef = this.modalService.show(
          SelectRequestModalComponent,
          Object.assign({}, {class: 'modal-dialog-centered select-survey-new xxl-popup-product', initialState}),
        );

        const metaData = {
          "log":{
            "organisation_id": this.org_uid,
            "message": "Subscription expired"
          },
          "audit_log": "CLICK_REQUEST_FORBIDDEN"
        }
        this.planservice.postLog(metaData)
      } else if(this.valid_start_time<this.current_time && this.valid_end_time>this.current_time && (this.state.active==false || this.state.payment_status===2)){
        let initialState = {
            message: $localize`Unfortunately, your subscription is pending activation. `,
            showLink: true
          }
        this.bsModalRef = this.modalService.show(
          SelectRequestModalComponent,
          Object.assign({}, {class: 'modal-dialog-centered select-survey-new xxl-popup-product', initialState}),
        );

        const metaData = {
          "log":{
            "organisation_id": this.org_uid,
            "message": "Subscription unpaid or inactive"
          },
          "audit_log": "CLICK_REQUEST_FORBIDDEN"
        }
        this.planservice.postLog(metaData)
      }else{
        this.openSelectReferenceModal()
      }
    }else{
      let initialState = {
          message: $localize`Unfortunately, your subscription is pending activation. `,
          showLink: true
        }
      this.bsModalRef = this.modalService.show(
        SelectRequestModalComponent,
        Object.assign({}, { class: 'modal-dialog-centered select-survey-new xxl-popup-product', initialState}),
      );

      const metaData = {
        "log":{
          "organisation_id": this.org_uid,
          "message": "Subscription unpaid or inactive"
        },
        "audit_log": "CLICK_REQUEST_FORBIDDEN"
      }
      this.planservice.postLog(metaData)
    }
  }
  openSelectReferenceModal() {
    this.selectCheckTypeModal = this.modalService.show(
      SelectCheckTypeModalComponent,
      Object.assign({}, { class: 'modal-dialog modal-dialog-centered xxl-popup xxl-popup-product'}),
    );
    this.selectCheckTypeModal.content.closeBtnName = 'Close';

    this.selectCheckTypeModal.content.selectClick.subscribe(res => {
      this.router.navigateByUrl('/request', { state: {
        checkType: res.data,
        template: res?.template,
        preFill: this.preFill
      } });
    });

  }

}
